import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import toLower from 'lodash/toLower';

import useFetch from '../hooks/useFetch';
import { getUserToken } from '../selectors/user';
import Api from '../api';

/**
 * @return {null}
 */
function SettingsProvider({ children }) {
  const [isReady, setIsReady] = useState(false);
  const { response = {}, onFetch } = useFetch('settings', Api.SETTINGS, {});
  const { i18n } = useTranslation();
  const token = useSelector(getUserToken());

  const currentLang = useMemo(() => {
    if (response.language) {
      const lang = toLower(response.language);
      i18n.changeLanguage(lang);
      moment.locale(lang, {
        week: {
          dow: 1,
          doy: 1,
        },
      });
      return lang;
    } else {
      return 'en';
    }
  }, [response.language]);

  const props = useMemo(
    () => ({
      isTrial: response.trial,
      expireDate: response.expire,
      lang: currentLang,
    }),
    [response, currentLang]
  );

  useEffect(() => {
    const token = window.localStorage.getItem('_token');

    if (token) {
      onFetch();
    }
  }, [token]);

  return children
    ? typeof children === 'function'
      ? children(props)
      : children
    : null;
}

export default SettingsProvider;
